import React, {Component} from 'react'
import PaymentTypeEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class PaymentTypeNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }


    render() {
        return (
            <div>
                <PaymentTypeEditForm />
            </div>
        );
    }
}

export default PaymentTypeNew


// WEBPACK FOOTER //
// ./src/payment-type/new.component.jsx